/**
 * Arquivo de reducer para o whitelabel.
 * Gerencia o estado relacionado ao whitelabel na aplicação.
 * Utiliza Redux para atualizar o estado com base nas ações despachadas.
 */

const initialState = {
  ambient: "",
  analyticsID: "",
  adSenseID: "",
  apiCode: "",
  btnHomeLink: "",
  btnHomeTitle: "",
  facebook: "",
  heightLogo: "",
  identify: "",
  instagram: "",
  isWhatsapp: "",
  linkFavicon: "",
  linkedin: "",
  linkBeConnect: "",
  logo: "",
  metaKeywords: "",
  metaText: "",
  metaTitle: "",
  moduleID: 0,
  name: "",
  partnershipDescription: "",
  partnershipTitle: "",
  phone: "",
  tabImg: "",
  tabTitle: "",
  title: "",
  urlApi: "",
  urlChangePassword: "",
};

export default function (state = initialState, action: any) {
  switch (action?.type) {
    case "CHANGE_WHITELABEL":
      return {
        ...state,
        ambient: action.payload.ambient,
        analyticsID: action.payload.analyticsID,
        adSenseID: action.payload.adSenseID,
        apiCode: action.payload.apiCode,
        btnHomeTitle: action.payload.btnHomeTitle,
        btnHomeLink: action.payload.btnHomeLink,
        facebook: action.payload.facebook,
        heightLogo: action.payload.heightLogo,
        identify: action.payload.identify,
        instagram: action.payload.instagram,
        isWhatsapp: action.payload.isWhatsapp,
        linkBeConnect: action.payload.linkBeConnect,
        linkedin: action.payload.linkedin,
        linkFavicon: action.payload.linkFavicon,
        logo: action.payload.logo,
        metaTitle: action.payload.metaTitle,
        metaText: action.payload.metaText,
        metaKeywords: action.payload.metaKeywords,
        moduleID: action.payload.moduleID,
        name: action.payload.name,
        partnershipTitle: action.payload.partnershipTitle,
        partnershipDescription: action.payload.partnershipDescription,
        phone: action.payload.phone,
        tabImg: action.payload.tabImg,
        tabTitle: action.payload.tabTitle,
        title: action.payload.title,
        urlApi: action.payload.urlApi,
        urlChangePassword: action.payload.urlChangePassword,
      };
    default:
      return {
        ...state,
      };
  }
}
